import React, { Component } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import KpsListItem from "../../core-elements/KpsListItem";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import { Trans, withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import { Typography } from "@material-ui/core/";
import DisplayUser from "../user/DisplayUser";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import { taxServiceClient } from "../../AxiosClient";
import Link from "@material-ui/core/Link";
import DisplayDocumentType from "../DisplayDocumentType";
import DocumentCategories from "../document/DocumentCategories";
import moment from "moment";

const styles = (theme) => ({
  iconSpan: {
    marginRight: theme.spacing(1),
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  secondarySpan: {
    verticalAlign: "middle",
    // marginLeft: "5px"
  },
});
export class ItemKnowledgeItem extends Component {
  state = {
    extendedString: "",
  };

  componentDidMount() {
    this.extendedInfo(this.props.extendedSettings);
    this.secondaryInfo(this.props.listSettings);
    this.defaultFullscreenInfo(this.props.extendedSettings);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }

  render() {
    const child = (
      <KpsListItem
        preText={this.props.preText}
        isPortlet={this.props.isPortlet}
        onItemClick={this.onItemClick}
        extendedString={this.state.extendedString}
        provided={this.props.provided}
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.preText}
        {this.props.fullscreen ? (
          <Link
            component="button"
            color="inherit"
            underline="none"
            style={{ textAlign: "left" }}
            // onClick={this.onItemClick}
          >
            {this.props.data.documentTitle}
          </Link>
        ) : (
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={this.props.data.documentTitle}
            secondary={this.state.secondaryString}
          />
        )}
      </KpsListItem>
    );
    if (this.props.snapshot && this.props.snapshot.isDragging) {
      return ReactDOM.createPortal(child, document.body);
    }
    return child;
  }

  onItemClick = () => {
      taxServiceClient
        .get(
          "/topic/" +
            this.props.data.topic.topicId +
            "/expertaccess/" +
            this.props.data.knowledgeSource.classification +
            "/"
        )
        .then((res) => {
          res.data === true
            ? this.props.history.push({
                pathname: `/full/knowledgeitem/${this.props.data.itemId}`,
              })
            : this.props.history.push({
                pathname: `/full/document/${this.props.data.documentId}`,
              });
        });
  };
  defaultFullscreenInfo(settings) {
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.knowledgeItemOptions.length; i++) {
        settings.push({ label: this.props.knowledgeItemOptions[i], order: i });
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  getSettingInfo = (setting) => {
    if (
      setting.label === "settings_knowledge_item_author_name" ||
      setting.label === "settings_knowledge_item_live_revision_author"
    ) {
      return (
        <TableCell>
          <DisplayUser
            userId={
              this.props.data &&
              this.props.data.hasOwnProperty(
                this.props.itemMappings[setting.label].data.userId
              ) &&
              this.props.data[
                this.props.itemMappings[setting.label].data.userId
              ]
            }
            user={
              this.props.data &&
              this.props.data.hasOwnProperty(
                this.props.itemMappings[setting.label].data
              ) &&
              this.props.data[this.props.itemMappings[setting.label].data]
            }
          />
        </TableCell>
      );
    }

    if (setting.label === "global_topic") {
      return (
        <>
          <TableCell>
            <DisplayLocation
              type="TOPIC"
              itemId={
                this.props.data[this.props.itemMappings[setting.label].data]
                  .topicId
              }
              topicId={
                this.props.data[this.props.itemMappings[setting.label].data]
                  .topicId
              }
              title={
                this.props.data[this.props.itemMappings[setting.label].data]
                  .topicName
              }
            />
          </TableCell>
        </>
      );
    }

    if (setting.label === "settings_knowledge_item_document_type_name") {
      return (
        <TableCell>
          <DisplayDocumentType
            documentTypeId={
              this.props.data[this.props.itemMappings[setting.label].data]
            }
          />
        </TableCell>
      );
    }

    if (setting.label === "settings_document_categories") {
      return (
        <TableCell>
          <DocumentCategories
            chipsOnly
            defaultValue={this.props.data.categories}
          />
        </TableCell>
      );
    }

    return (
      <TableCell>
        {this.props.data && (
          <>{this.getElementToDisplay(setting, this.props.data)}</>
        )}
      </TableCell>
    );
  };
  getElementToDisplay = (setting, data) => {
    let value = this.props.data[this.props.itemMappings[setting.label].data];

    return (
      <>
        {this.props.itemMappings[setting.label].type === "date" &&
        value &&
        value !== null
          ? moment(value).format("LLL")
          : value}
      </>
    );
  };
  extendedInfo(settings) {
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.knowledgeItemOptions.length; i++) {
        settings.push({ label: this.props.knowledgeItemOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <TableRow>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {this.getSettingInfo(setting)}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString: extendedString });
  }
  returnSettingItem = (settings) => {
    let { classes } = this.props;
    let fontWeight = {
      fontWeight: this.props.fullscreen ? "bold" : "normal",
      paddingRight: this.props.theme.spacing(1),
    };
    return (
      <span className={classes.secondarySpan}>
        {settings === "settings_document_categories" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("global_category_plural")}
              :
            </div>
            <div>
              {" "}
              <DocumentCategories
                chipsOnly
                defaultValue={this.props.data.categories}
              />
            </div>
          </div>
        )}
        {settings === "settings_knowledge_item_description" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>{this.props.t("global_description")}</div>
            <div>: {this.props.data.description}&nbsp;</div>
          </div>
        )}
        {settings === "global_topic" && (
          <>
            <DisplayLocation
              type="TOPIC"
              itemId={
                this.props.data[this.props.itemMappings[settings].data].topicId
              }
              topicId={
                this.props.data[this.props.itemMappings[settings].data].topicId
              }
              title={
                this.props.data[
                  this.props.itemMappings[settings].data.topicName
                ]
              }
            />
          </>
        )}
        {settings === "settings_knowledge_item_author_name" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_author_name")}
              :{" "}
            </div>
            <div>
              {this.props.data &&
                this.props.data.author &&
                this.props.data.author.userId && (
                  <DisplayUser
                    noAvatar
                    userId={this.props.data.author.userId}
                    user={this.props.data.author}
                  />
                )}
            </div>
          </div>
        )}
        {settings === "settings_knowledge_item_live_revision_author" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_live_revision_author")}
              :{" "}
            </div>
            <div>
              {this.props.data.liveRevisionAuthor &&
                this.props.data.liveRevisionAuthor.userId && (
                  <DisplayUser
                    noAvatar
                    userId={this.props.data.liveRevisionAuthor.userId}
                    user={this.props.data.liveRevisionAuthor}
                  />
                )}
            </div>
          </div>
        )}
        {settings === "settings_knowledge_item_knowledge_source" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("global_knowledge_source")}
            </div>
            <div>{this.props.data.knowledgeSource}&nbsp;</div>
          </div>
        )}
        {settings === "settings_knowledge_item_created_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_created_date")}
            </div>
            <div>{moment(this.props.data.dateCreated).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_knowledge_item_modified_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_modified_date")}
            </div>
            <div>{moment(this.props.data.modifiedDate).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_knowledge_item_approved_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_approved_date")}
            </div>
            <div>{moment(this.props.data.approvedDate).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_knowledge_item_withdraw_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_withdraw_date")}
            </div>
            <div>{moment(this.props.data.withdrawDate).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_knowledge_item_expiry_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_expiry_date")}
            </div>
            <div>{moment(this.props.data.expiryDate).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_knowledge_item_document_title" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_document_title")}
            </div>
            <div>{this.props.data.documentTitle}&nbsp;</div>
          </div>
        )}
        {settings === "settings_knowledge_item_visible_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_visible_date")}
            </div>
            <div>{this.props.data.visibleDate}&nbsp;</div>
          </div>
        )}
        {settings === "settings_knowledge_item_revalidation_behaviour" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_revalidation_behaviour")}
            </div>
            <div>{this.props.data.revalidationBehaviour}&nbsp;</div>
          </div>
        )}
        {settings === "settings_knowledge_item_revalidation_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_revalidation_date")}
            </div>
            <div>{moment(this.props.data.revalidationDate).format("LLL")}</div>
          </div>
        )}
        {settings === "settings_knowledge_item_document_type_name" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_document_type_name ")}
            </div>
            <div>{this.props.data.documentTypeName}&nbsp;</div>
          </div>
        )}
        {settings === "settings_knowledge_item_is_ready_for_approval" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_knowledge_item_is_ready_for_approval ")}
            </div>
            <div>{this.props.data.readyForApproval}&nbsp;</div>
          </div>
        )}
      </span>
    );
  };
  checkForIcons = () => {
    let hasIcons = false
    if (this.props.data.isReadyForApproval) {
      hasIcons = true
    }
    if (this.props.data.workflowState && (
        this.props.data.workflowState === "AWAITING_APPROVAL" ||
        this.props.data.workflowState === "AWAITING_REVIEW" ||
        this.props.data.workflowState === "AWAITING_PUBLISH" ||
        this.props.data.workflowState === "REVIEWED_AWAITING_APPROVAL_STAGE" )) {
      hasIcons = true
    }
    return hasIcons

  }
  secondaryInfo(settings) {
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        for (let i = 0; i < this.props.knowledgeItemOptions.length; i++) {
          settings.push({
            label: this.props.knowledgeItemOptions[i],
            order: i,
          });
        }
      } else {
        try {
          let jsonsettings = JSON.parse(settings);
          settings = jsonsettings;
        } catch (x) {
          settings = [{ label: settings, order: 0 }];
        }
      }
    } else {
      if (this.props.secondaryInfo) {
        return this.props.secondaryInfo;
      }
      if (!settings) {
        settings = "settings_knowledge_item_author_name";
      }
    }
    const hasIcons = this.checkForIcons()
    const { classes } = this.props;
    let info = (
      <div style={{ display: "flex" }}>
        {hasIcons === true && (
        <span className={classes.iconSpan}>
          {this.props.data.workflowState && (
            <>
              {!!this.props.data.withdrawDate && (
                <Tooltip
                  title={
                    <Typography>{this.props.t("global_withdrawn")}</Typography>
                  }
                  aria-label={this.props.t("global_withdrawn")}
                >
                  <HighlightOffIcon color="primary" />
                </Tooltip>
              )}
              {this.props.data.workflowState === "AWAITING_APPROVAL" && (
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("document_awaiting_approval")}
                    </Typography>
                  }
                  aria-label={this.props.t("document_awaiting_approval")}
                >
                  <AssignmentLateIcon color="primary" />
                </Tooltip>
              )}
              {this.props.data.workflowState === "AWAITING_REVIEW" && (
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("document_awaiting_review")}
                    </Typography>
                  }
                  aria-label={this.props.t("document_awaiting_review")}
                >
                  <AssignmentLateIcon color="primary" />
                </Tooltip>
              )}
              {this.props.data.workflowState === "AWAITING_PUBLISH" && (
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("document_awaiting_publish")}
                    </Typography>
                  }
                  aria-label={this.props.t("document_awaiting_publish")}
                >
                  <AssignmentLateIcon color="primary" />
                </Tooltip>
              )}
              {this.props.data.workflowState ===
                "REVIEWED_AWAITING_APPROVAL_STAGE" && (
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("document_awaiting_approval_stage")}
                    </Typography>
                  }
                  aria-label={this.props.t("document_awaiting_approval_stage")}
                >
                  <AssignmentLateIcon color="primary" />
                </Tooltip>
              )}
            </>
          )}
          {this.props.data.isReadyForApproval && (
            <Tooltip
              title={
                <Typography>{this.props.t("ready_for_approval")}</Typography>
              }
              aria-label={this.props.t("ready_for_approval")}
            >
              <AssignmentLateIcon color="secondary" />
            </Tooltip>
          )}
        </span>
        )}
        {this.returnSettingItem(settings)}
      </div>
    );
    this.setState({ secondaryString: info });
  }
}

const mapStateToProps = (state) => ({
  knowledgeItemOptions: state.selectionOption.knowledgeItemSettingsOptions,
  itemMappings: state.itemMappings.ItemKnowledgeItem,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    forwardRef: true,
  }
)(
  withStyles(styles)(
    withRouter(withTheme(withTranslation()(ItemKnowledgeItem)))
  )
);
